<div class="content" *ngIf="!isEmpty() && !content?.isPigeonhole">
  <div class="level" *ngFor="let level of content.levels">
    <div class="item" *ngIf="level.pallets && level.pallets.length > 0; else noPallets">
      
      <div class="level-name" [ngClass]="getGroundClass(level.groundGroup)">
        <!-- <span class="order" *ngIf="level.type == MapTooltipLevelType.REGULAR">{{level.order}} - </span> -->
        <span class="name">{{level.name}}</span>
        <span class="pallet-qty"> ({{level.palletQty}} pallets)</span>
      </div>

      <div *ngFor="let pallet of level.pallets" >
        <!-- <div class="pallet-name">{{pallet.name}}</div> -->
        <ng-container *ngIf="pallet.skuQty < 2; else multipleSkus">
          <div *ngFor="let product of pallet.products" >
            <div *ngIf="product.sku" class="sku" [ngClass]="getGroundClass(level.groundGroup)">
              {{product.sku}} - quantidade: {{product.quantity | number:'1.0-0':'pt-BR'}}
            </div>
          </div>
        </ng-container>
        <ng-template #multipleSkus>
          <div class="sku" [ngClass]="getGroundClass(level.groundGroup)">
            pallet multireferência <span class="sku-qty">({{pallet.skuQty}} skus)</span>
          </div>
        </ng-template>
      </div>
        <div *ngIf="level.palletQty > 2" class="sku" [ngClass]="getGroundClass(level.groundGroup)">
          +{{level.palletQty - 2}} pallets
        </div>
    </div>
    <ng-template #noPallets>
      <div class="item" *ngIf="level.type == MapTooltipLevelType.REGULAR">
        <div class="level-name empty-level" [ngClass]="getGroundClass(level.groundGroup)">
          <!-- <span class="order">{{level.order}} - </span> -->
          <span class="name">{{level.name}}</span>
          (vazio)
        </div>
      </div>
    </ng-template>
  </div>
</div>
<div class="content" *ngIf="content?.isPigeonhole">
  <!--  vazia ou não, a posição PIGEONHOLE deve exibir sempre essa tooltip -->
  <div class="level">
    <div class="item">
      <div class="level-name">Posição escaninho, selecione para mais detalhes</div>
    </div>
  </div>
</div>
<div class="empty" *ngIf="isEmpty() && !content?.isPigeonhole">
  <div class="level">
    <div class="item">
      <div class="level-name">Não existem pallets aqui.</div>
    </div>
  </div>
</div> 